/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelCategoriesList } from '../../models/travel-categories-list';

export interface TravelControllerGetCategories$Params {
}

export function travelControllerGetCategories(http: HttpClient, rootUrl: string, params?: TravelControllerGetCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelCategoriesList;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelCategoriesList;
      }>;
    })
  );
}

travelControllerGetCategories.PATH = '/travel/categories';
